import { useState } from "react";
import { ChevronDown, ChevronRight, Loader2, Boxes } from "lucide-react";
import api from "@/lib/api";

const num = (n) => (n == null ? "—" : Number(n).toLocaleString("es-MX", { maximumFractionDigits: 3 }));
const fecha = (iso) => (iso ? new Date(iso).toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");
const TIPO = { incidencia: "Diferencia en recepción", merma_incidencia: "Merma por incidencia", reversion_merma_incidencia: "Reversión de merma", regreso_no_enviado: "Regreso al origen (no enviado)", devolucion_salida: "Devolución: salida", devolucion_entrada: "Devolución: entrada en origen" };

/** Historial colapsable de movimientos de stock generados por una incidencia (auditoría sin ir a Trazabilidad). */
export default function MovimientosIncidencia({ inc }) {
  const [open, setOpen] = useState(false);
  const [movs, setMovs] = useState(null);
  function toggle() {
    const next = !open; setOpen(next);
    if (next && movs === null) api.get(`/incidencias/${inc.id}/movimientos`).then((r) => setMovs(r.data)).catch(() => setMovs([]));
  }
  return (
    <div className="mt-1" data-testid={`inc-movs-${inc.id}`}>
      <button type="button" onClick={toggle} className="flex items-center gap-1 text-[10px] font-semibold text-brand-slate hover:text-brand-ink" data-testid={`inc-movs-toggle-${inc.id}`}>
        {open ? <ChevronDown className="w-3 h-3" /> : <ChevronRight className="w-3 h-3" />}<Boxes className="w-3 h-3" /> Movimientos de stock{movs ? ` (${movs.length})` : ""}
      </button>
      {open && (
        <div className="mt-1 rounded-lg border border-brand-line/70 bg-brand-surface/60 overflow-x-auto" data-testid={`inc-movs-lista-${inc.id}`}>
          {movs === null && <div className="p-2 text-[10px] text-brand-muted flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> Cargando…</div>}
          {movs && movs.length === 0 && <div className="p-2 text-[10px] text-brand-muted" data-testid={`inc-movs-vacio-${inc.id}`}>Esta incidencia no generó movimientos de stock (solo ajuste de pedido o registro informativo).</div>}
          {movs && movs.length > 0 && (
            <table className="w-full text-[10px]">
              <thead><tr className="text-left text-brand-muted border-b border-brand-line/60"><th className="px-2 py-1">Fecha</th><th className="px-2 py-1">Tipo</th><th className="px-2 py-1">Sucursal</th><th className="px-2 py-1">Insumo</th><th className="px-2 py-1 text-right">Δ</th><th className="px-2 py-1 text-right">Saldo</th><th className="px-2 py-1">Usuario / nota</th></tr></thead>
              <tbody>
                {movs.map((m) => (
                  <tr key={m.id} className="border-b border-brand-line/40 last:border-0" data-testid={`inc-mov-${m.id}`}>
                    <td className="px-2 py-1 whitespace-nowrap text-brand-muted">{fecha(m.created_at)}</td>
                    <td className="px-2 py-1"><span className="chip chip-ink text-[9px]">{TIPO[m.tipo] || m.tipo}</span></td>
                    <td className="px-2 py-1 text-brand-slate">{m.sucursal_nombre}</td>
                    <td className="px-2 py-1 text-brand-ink">{m.componente_nombre} <span className="font-mono text-brand-muted">{m.componente_sku}</span></td>
                    <td className={`px-2 py-1 text-right font-mono font-bold ${m.delta > 0 ? "text-emerald-700" : m.delta < 0 ? "text-rose-600" : "text-brand-muted"}`}>{m.delta > 0 ? "+" : ""}{num(m.delta)} {m.unidad}</td>
                    <td className="px-2 py-1 text-right font-mono text-brand-muted">{m.saldo_anterior == null ? "—" : `${num(m.saldo_anterior)} → ${num(m.saldo_nuevo)}`}</td>
                    <td className="px-2 py-1 text-brand-slate">{m.usuario_nombre}{m.nota ? ` · ${m.nota}` : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
